import axios from 'axios';

/**
 * Fetches the list of client industries from the server
 * @returns {Promise<Array>} A promise that resolves to the list of industries
 */
export const fetchClientIndustries = async () => {
    try {
        const options = {
            withCredentials: true,
            method: 'GET',
            url: `${process.env.REACT_APP_BASE_SERVER}/client/industry`
        };

        const response = await axios(options);

        if (response.data.success && Array.isArray(response.data.data)) {
            return response.data.data.map(i => ({
                id: i.industry_id,
                label: i.label,
                search: `${i.label} ${i.industry_name} ${i.idx_name} ${i.gri_name} ${i.sbti_name}`
            }));
        }

        return [];
    } catch (error) {
        console.error('Error fetching client industries:', error);
        return [];
    }
};

export const fetchMyGroupClients = async () => {
    try {
        const options = {
            withCredentials: true,
            method: 'GET',
            url: `${process.env.REACT_APP_BASE_SERVER}/my-group-clients`
        };

        const response = await axios(options);

        if (response.data.success && Array.isArray(response.data.data)) {
            return response.data.data.map(i => ({
                id: i.client_id,
                label: i.client_name,
                search: i.client_name
            }));
        }

        return [];
    } catch (error) {
        console.error('Error fetching my group clients:', error);
        return [];
    }
};


